export const formatNumber = (num) => {
  // return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : num

  if (!num) {
    return num
  }

  const numString = num.toString()
  const arr = numString.match(/(.*?)\.(.*)/)
  if (arr && arr.length > 0) {
    const key = arr[1].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    const val = arr[2]
    return key + '.' + val
  } else {
    return numString.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
}
//// Used these later on

// const arrayToObject = (array, keyField) =>
//   array.reduce((obj, item) => {
//       obj[item[keyField]] = item
//       return obj
//     }, {}
//   )
//
// export const getLabel = (options, value, name) => {
//   // console.log('---name,value---', name, ',', value)
//   if (!value) {
//     value = 'null'
//   }
//   const x = arrayToObject(options, 'value')
//   if (x && x[value] != undefined  && x[value] )  {
//     return x[value].label
//   } else {
//     // console.log('---name,value---', name, ',', value, ',', options)
//     return 'N/A'
//   }
// }

export function flatten(obj, result, commonData) {
  return Object.entries(obj).reduce((r, [key, val]) => {
    if (typeof val === 'object') {
      return flatten(val, result, commonData)
    } else {
      result[key] = commonData[key] // val
    }
    return r
  }, {})
}

export const formatEntries = (obj, labelName) => {
  const flattedObj = flattenMultiLevelObject(obj)

  return Object.entries(flattedObj).reduce((result, [key, val]) => {
    if (val === undefined) {
      return result
    } else {
      return result + ' - ' + key + ':' + val
    }
  }, labelName)
}

export const gaEventWrapper = (eventName, action, label) => {
  ga('send', 'event', eventName, action, label)
  // try {
  //    ga('send', 'event', 'PFD_Events', action, label)
  // } catch (error) {
  //    console.error(error)
  // }
}

export const flattenObject = (obj) => {
  return Object.keys(obj).reduce((acc, current) => {
    const key = `${current}`
    const currentValue = obj[current]
    if (Array.isArray(currentValue) || Object(currentValue) === currentValue) {
      Object.assign(acc, flattenObject(currentValue))
    } else {
      acc[key] = currentValue
    }
    return acc
  }, {})
}

export const flattenMultiLevelObject = (source) => {
  const target = {}

  const helper = (current, target, keyPrefix) => {
    for (let key in current) {
      let val = current[key]

      if (typeof val !== 'object') {
        if (keyPrefix == null || keyPrefix == '') {
          target[key] = val
        } else {
          if (key == null || key == '') {
            target[keyPrefix] = val
          } else {
            target[keyPrefix + '_' + key] = val
          }
        }
      } else {
        if (keyPrefix == null || keyPrefix == '') {
          helper(val, target, key)
        } else {
          helper(val, target, keyPrefix + '_' + key)
        }
      }
    }
  }

  helper(source, target, '')

  return target
}

export const hashCode = (s) => {
  let h
  for (let i = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0

  return h
}

export const simulateClick = (elem) => {
  // Create our event (with options)
  const evt = new MouseEvent('click', {
    bubbles: false,
    cancelable: true,
    view: window,
  })
  elem.dispatchEvent(evt)
}

export const numberFormatted = (obj) => {
  Object.keys(obj).forEach((k) => {
    if (typeof obj[k] === 'object') return numberFormatted(obj[k])
    else if (typeof obj[k] !== 'boolean' && !isNaN(Number(obj[k]))) obj[k] = Number(obj[k])
  })

  return obj
}

export function migrateJsonUpload(uploadJson) {
  const legacyJobs = uploadJson.jobs
  const legacyCalcInput = uploadJson.calculation.input

  const { showOptimizedModels, searchKeyword, rowsData, sortBy, ...input } = legacyCalcInput

  const currentOutput = uploadJson.calculation.output
  const currentOutputResult = currentOutput?.result

  const output = {
    result: {
      showOptimizedModels: showOptimizedModels ?? currentOutputResult.showOptimizedModels,
      searchKeyword: searchKeyword ?? currentOutputResult.searchKeyword,
      sortBy: sortBy ?? currentOutputResult.sortBy,
      rowsData: rowsData ?? currentOutputResult.rowsData,
      isLoading: currentOutputResult?.isLoading ?? false,
      isError: currentOutputResult?.isError ?? false,
    },
    jobs: legacyJobs ?? currentOutput.jobs,
  }

  return {
    calculation: {
      input,
      output,
    },
  }
}

export const formatPercentage = (number) => `${parseFloat(number).toFixed(2)}%`